import {
  Button,
  Columns,
  LoadingModule,
  SaveFormModule,
} from '@domain-group/suit-theme'

import handleCallbackAction from '@functions/handleCallbackAction'

import usePortal, { usePortalForm } from '@hooks/usePortal'

import PageLayout from '../../../../components/PageLayout'
import PortalTools from '../../../../components/PortalTools'

import ExternalFTP from '../ExternalFTP'
import InternalFTP from '../InternalFTP'
import PortalDetails from '../PortalDetails'
import PortalOptionsList from '../PortalOptionsList'
import PortalSettings from '../PortalSettings'

const PageContent = (props: { portalId: number}) => {
  const { portalId } = props

  const portalPayload = usePortal({ id: portalId })
  const {
    portal,
    callbacks: {
      updatePortal,
    },
    loading,
    updating,
  } = portalPayload

  // @ts-expect-error TS2345
  const portalFormPayload = usePortalForm(portal, { validateOn: 'change' })
  const { entityState, saveEnabled } = portalFormPayload

  const updatePortalPayload = {
    callbacks: {
      action: updatePortal,
    },
    entityParams: entityState,
    toastText: 'Portal Updated',
  }

  return (
    <PageLayout entityPayload={portalPayload} activeTabBarItemKey="details">
      <Columns.Main>
        <LoadingModule loading={loading} times={3} />

        {!loading && (
          <>
            <PortalDetails portalFormPayload={portalFormPayload} />

            <InternalFTP portalFormPayload={portalFormPayload} />

            <ExternalFTP portalFormPayload={portalFormPayload} />

            <SaveFormModule>
              <Button
                buttonStyle="primaryCreate"
                disabled={!saveEnabled}
                loading={updating}
                marginLeft="auto"
                // @ts-expect-error TS2345
                onClick={() => handleCallbackAction(updatePortalPayload)}
                size="medium"
              >
                Save Details
              </Button>
            </SaveFormModule>

            <PortalOptionsList portalId={portalId} />
          </>
        )}
      </Columns.Main>

      <Columns.Sidebar>
        <PortalTools portalId={portalId} />

        {/*
         // @ts-expect-error TS2322 */}
        <PortalSettings callbacks={{ updatePortal }} portal={portal} />
      </Columns.Sidebar>
    </PageLayout>
  )
}

export default PageContent
